import { useState } from 'react'
import cx from 'classnames'
import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronDown2, Shadow2 as Icon } from 'blaze-ui/icons'
import { useUpdateStyle } from 'components/VisualStudioPlayground/VisualEditor/hooks/useUpdateStyle'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, SharedStyle, track } from '@tldraw/tldraw'
import { IShadowStyle, ShadowStyle } from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { SliderField } from 'components/Design/SliderField/SliderField'
import { ColorDetailRow } from './ColorDetailRow'

const defaultShadow = {
  x: 4,
  y: 4,
  blur: 4,
  color: '#000000',
  opacity: 0.25,
}

interface Props {
  editor: Editor
  style: SharedStyle<IShadowStyle>
}

export const Shadow = track(({ editor, style }: Props) => {
  const updateStyle = useUpdateStyle(editor)
  const [isExpanded, setIsExpanded] = useState(false)

  const shadowStyle = style.type === 'mixed' ? null : style.value

  if (style.type === 'mixed') return null

  const isActive = !!style.value
  const formStyle = shadowStyle || defaultShadow

  return (
    <div className={Styles.colorSection}>
      <div className={Styles.actionRow} onClick={() => setIsExpanded(!isExpanded)}>
        <Icon color="var(--selected-fill)" />
        <span className={Styles.actionName}>
          <Text variant="smallList">Shadow</Text>
        </span>
        <ToggleButton
          name="shadow"
          size="sm-md"
          checked={isActive}
          handleChange={(e) => {
            if (isActive) {
              updateStyle(ShadowStyle, null)
              setIsExpanded(false)
            } else {
              updateStyle(ShadowStyle, defaultShadow)
              setIsExpanded(true)
            }
          }}
        />
        {isExpanded ? <ChevronDown2 color="var(--dark-60)" /> : <ChevronRightSmall size={20} color="var(--dark-60)" />}
      </div>
      {isExpanded && (
        <div className={Styles.expandedSection}>
          <div className={cx(Styles.form, { [Styles.disabled]: !isActive })}>
            <div className={Styles.field}>
              <ColorDetailRow
                editor={editor}
                label="Shadow Color"
                color={formStyle.color}
                updateColor={(color) => updateStyle(ShadowStyle, { ...shadowStyle, color })}
                isDisabled={!isActive}
              />
            </div>
            <div className={Styles.field}>
              <SliderField
                size="xs"
                label="Blur"
                value={formStyle.blur}
                minValue={0}
                maxValue={100}
                step={1}
                onChange={(blur) => updateStyle(ShadowStyle, { ...shadowStyle, blur })}
                isDisabled={!isActive}
              />
            </div>
            <div className={Styles.row}>
              <div className={Styles.field}>
                <SliderField
                  size="xs"
                  label="X"
                  isDisabled={!isActive}
                  value={formStyle.x}
                  onChange={(x) => updateStyle(ShadowStyle, { ...shadowStyle, x })}
                  step={1}
                  minValue={-100}
                  maxValue={100}
                  pinnedValue={0}
                />
              </div>

              <div className={Styles.field}>
                <SliderField
                  size="xs"
                  label="Y"
                  isDisabled={!isActive}
                  value={formStyle.y}
                  onChange={(y) => updateStyle(ShadowStyle, { ...shadowStyle, y })}
                  step={1}
                  minValue={-100}
                  maxValue={100}
                  pinnedValue={0}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
})
